import { useMutation } from "react-query";
import updateUnclaimedMoney from "../services/updateUnclaimedMoney";

function useUpdateUnclaimedMoney() {
  return useMutation(["update-unclaimed-money"], updateUnclaimedMoney);
}

export default useUpdateUnclaimedMoney;
